export default __webpack_public_path__ + "static/media/download.b01c63a3.svg";